import Icon, {ilsLoading} from "../Icon";
import React from "react";
import '../../../assets/sass/components/feedback/loading.scss';

const Loading = props => {
    const text = props.text || "Loading...";
    const details = props.details || "Please wait. While we fetch the data";

    return (
        <div className="feedback-loading">
            <Icon className="feedback-loading--icon" svg={ilsLoading}/>
            <span className="feedback-loading--text"> {text} </span>
            <span className="feedback-loading--details"> {details} </span>
        </div>
    );
};

const WithWrapper = (component) => <div className="w-100 h-100 d-flex justify-content-center align-items-center"> {component} </div>;
Loading.WithWrapper = props => WithWrapper(<Loading {...props}/>);

export default Loading;
